import React from 'react';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Stack, Typography } from '@mui/material';

import DebugModal from '~/components/DebugModal/DebugModal';

import { VoucherLog } from '~/services/PromoService';

import { getVoucherLogWarnings } from '~/utils/voucherLogWarnings';

type Props = {
  log: VoucherLog;
};

export default function VoucherLogWarningsButton({ log }: Props) {
  const warnings = getVoucherLogWarnings(log);
  const flatWarnings = warnings.map((warning) => ({
    ...warning,
    ...(warning.metadata ?? {}),
  }));

  if (warnings.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap>
      <WarningAmberIcon color="warning" fontSize="small" />
      <DebugModal
        type="generic"
        hideIcon
        title={`Warnings (${warnings.length})`}
        data={{
          voucherLogId: log.voucherLogId,
          voucherId: log.voucherId,
          voucherUserId: log.voucherUserId,
          fkOrder: log.fkOrder ?? log.fk_order,
          userId: log.userId,
          warnings: flatWarnings,
        }}
      />
    </Stack>
  );
}
